const GoogleMapsStyle = [
    {
      "featureType": "landscape.man_made",
      "stylers": [
        {
          "color": "#fafafa"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "stylers": [
        {
          "color": "#c9eed4"
        }
      ]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#d6f5df"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "landscape.natural.landcover",
      "stylers": [
        {
          "color": "#d4f7de"
        }
      ]
    },
    {
      "featureType": "landscape.natural.terrain",
      "stylers": [
        {
          "color": "#d4f7de"
        }
      ]
    },
    {
      "featureType": "landscape.natural.terrain",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#708f8f"
        }
      ]
    },
    {
      "featureType": "poi.attraction",
      "stylers": [
        {
          "color": "#d4f7de"
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.business",
      "stylers": [
        {
          "color": "#d4f7de"
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "poi.government",
      "stylers": [
        {
          "color": "#d4f7de"
        }
      ]
    },
    {
      "featureType": "poi.medical",
      "stylers": [
        {
          "color": "#d4f7de"
        },
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "stylers": [
        {
          "color": "#d4f7de"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.place_of_worship",
      "stylers": [
        {
          "color": "#d4f7de"
        }
      ]
    },
    {
      "featureType": "poi.school",
      "stylers": [
        {
          "color": "#d4f7de"
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "poi.sports_complex",
      "stylers": [
        {
          "color": "#d4f7de"
        }
      ]
    },
    {
      "featureType": "poi.sports_complex",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "stylers": [
        {
          "color": "#c7e1e6"
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#bfe4ee"
        },
        {
          "visibility": "on"
        }
      ]
    }
];

export default GoogleMapsStyle;